import React, { useRef } from 'react';
import './PlaylistCard.css';
import { useTranslation } from 'react-i18next';

const images = importAll(require.context('../../assets/images', false, /\.(png|jpe?g|svg)$/));
function importAll(r) { let images = {}; r.keys().forEach((item) => { images[item.replace('./', '')] = r(item); }); return images; }

function PlaylistCard({ playlist, onPlayPlaylist, togglePlayPause, activeSong, isPlaying, style }) {
  const { i18n } = useTranslation();
  
  const isThisPlaylistActive = activeSong && playlist.songIds.includes(activeSong.id);
  const isCurrentlyPlaying = isPlaying && isThisPlaylistActive;

  const handlePlayClick = (e) => { 
    e.stopPropagation(); 
    if (isCurrentlyPlaying) {
      togglePlayPause();
    } else {
      onPlayPlaylist();
    }
  };
  
  const handleCardClick = () => {
    if (isThisPlaylistActive && !isPlaying) {
      togglePlayPause();
    } else if (!isThisPlaylistActive) {
      onPlayPlaylist();
    }
  };

  const cardRef = useRef(null);

  const handleMouseEnter = (e) => {
    const card = cardRef.current;
    if (!card) return;
    const ripple = card.querySelector('.portal-ripple');
    if (!ripple) return;

    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Remove old animation classes to allow it to run again
    ripple.classList.remove('animate');
    // We need to trigger a reflow for the browser to see the class removal
    void ripple.offsetWidth; 
    
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;

    // Add the class to start the animation
    ripple.classList.add('animate');
  };

  return (
    <div 
      className="playlist-card" 
      onClick={handleCardClick}
      ref={cardRef}
      onMouseEnter={handleMouseEnter}
      style={style}
    >
      <div className="card-image-container">
        <img src={images[playlist.imageSrc]} alt={playlist.name[i18n.language]} className="card-image" />
        <span className="portal-ripple"></span>
      </div>
      <div className="card-info">
        <span className="card-title">{playlist.name[i18n.language]}</span>
        <span className="card-description">{playlist.description[i18n.language]}</span>
      </div>
      <button 
        className={`card-play-button ${isCurrentlyPlaying ? 'playing' : ''}`} 
        onClick={handlePlayClick}>
        <i className={isCurrentlyPlaying ? "fas fa-pause" : "fas fa-play"}></i>
      </button>
    </div>
  );
}

export default PlaylistCard;